import React, { useState, useRef, useEffect } from 'react';
import { IconButton, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';
import { Search, Clear } from '@material-ui/icons';
import { toast } from '../../../../../redux/actions/UI';

const InputSearch = ({
  messageId,
  setLoading,
  setRows,
  orgId,
  getTableRowData,
}) => {
  const [searchText, setSearchText] = useState('');
  const dispatch = useDispatch();
  const debounceTimeout = 800;

  const fetchEvents = async text => {
    try {
      setLoading(true);

      const search = text ? { search: text } : {};
      const tableRows = await getTableRowData({ messageId, orgId, search });

      setLoading(false);
      setRows(tableRows);
    } catch (e) {
      console.error(e);
      dispatch(toast('error', 'Failed to fetch events data'));
    }
  };

  const handleClear = () => {
    setSearchText('');
    fetchEvents('');
  };

  const debouncedFetchRef = useRef();
  useEffect(() => {
    debouncedFetchRef.current = debounce(fetchEvents, debounceTimeout);
    return () => {
      debouncedFetchRef.current.cancel();
    };
  }, [messageId, orgId]);

  const handleChange = e => {
    const text = e.target.value;
    setSearchText(text);
    debouncedFetchRef.current(text);
  };

  return (
    <TextField
      label="Quick Search"
      variant="outlined"
      size="small"
      value={searchText}
      onChange={handleChange}
      InputProps={{
        style: { width: '250px' },
        endAdornment: (
          <>
            {searchText && (
              <IconButton size="small" onClick={handleClear}>
                <Clear fontSize="small" />
              </IconButton>
            )}
            <IconButton size="small" onClick={() => fetchEvents(searchText)}>
              <Search fontSize="small" />
            </IconButton>
          </>
        ),
      }}
    />
  );
};

export default InputSearch;
